import { render, staticRenderFns } from "./BasicToolbar.vue?vue&type=template&id=338c12e6&scoped=true"
import script from "./BasicToolbar.vue?vue&type=script&lang=js"
export * from "./BasicToolbar.vue?vue&type=script&lang=js"
import style0 from "./BasicToolbar.vue?vue&type=style&index=0&id=338c12e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338c12e6",
  null
  
)

export default component.exports